import { useState } from 'react'

import { Col, Form, Row } from 'react-bootstrap'
import { WrenchAdjustableCircleFill } from 'react-bootstrap-icons'
import { toast } from 'react-toastify'

import { Center } from '../../../../../components/Center'
import { CustomButton } from '../../../../../components/CustomButton'

import WmsInventarioService from '../../../../../services/database/WmsInventarioService'

import { sendErrorApiMessage } from '../../../../../utils/sendErrorApiMessage'

import { ComponentContainer, ComponentContent } from '../../styles'

export function Configuration({ inventory, setInventory, onNext }) {
  const [isCreateInventoryLoading, setIsCreateInventoryLoading] =
    useState(false)

  function handleChange(e) {
    const { name, value } = e.target

    setInventory((prevState) => ({
      ...prevState,
      info: {
        ...prevState.info,
        [name]: value,
      },
    }))
  }

  async function handleCreateInventory() {
    try {
      setIsCreateInventoryLoading(true)

      const inventoryId = await WmsInventarioService.create(inventory.info)

      setInventory((prevState) => ({
        ...prevState,
        info: {
          ...prevState.info,
          id: inventoryId,
        },
        isConfigConfirmed: true,
      }))

      toast.success('Inventário criado com sucesso!')

      onNext()
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível criar o inventário!')
    } finally {
      setIsCreateInventoryLoading(false)
    }
  }

  return (
    <>
      <ComponentContainer>
        <ComponentContent>
          <p>Crie o inventário com as configurações desejadas.</p>

          <Row>
            <Col>
              <Form.Label>Descrição</Form.Label>
              <Form.Control
                name="descricao"
                value={inventory.info.descricao}
                onChange={handleChange}
                disabled={inventory.isConfigConfirmed}
              />
            </Col>

            <Col>
              <Form.Label>Tipo</Form.Label>
              <Form.Select
                name="tipo"
                value={inventory.info.tipo}
                onChange={handleChange}
                disabled={inventory.isConfigConfirmed}
              >
                <option value="E">Endereço</option>
                <option value="P">Produto</option>
              </Form.Select>
            </Col>

            <Col>
              <Form.Label>Considerar Estoque</Form.Label>
              <Form.Select
                name="considera_estoque"
                value={inventory.info.considera_estoque}
                onChange={handleChange}
                disabled={inventory.isConfigConfirmed}
              >
                <option value="S">Sim</option>
                <option value="N">Não</option>
              </Form.Select>
            </Col>

            <Col>
              <Form.Label>Conferência Cega</Form.Label>
              <Form.Select
                name="conferencia_cega"
                value={inventory.info.conferencia_cega}
                onChange={handleChange}
                disabled={inventory.isConfigConfirmed}
              >
                <option value="S">Sim</option>
                <option value="N">Não</option>
              </Form.Select>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col>
              <Form.Label>Observações</Form.Label>

              <textarea
                name="observacoes"
                value={inventory.info.observacoes}
                onChange={handleChange}
                className="form-control"
                disabled={inventory.isConfigConfirmed}
                style={{
                  resize: 'none',
                }}
              ></textarea>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col>
              <Center jc="flex-start">
                <CustomButton
                  noMargin
                  title="Criar Inventário"
                  onClick={handleCreateInventory}
                  isDisabled={
                    !inventory.info.descricao || inventory.isConfigConfirmed
                  }
                  isLoading={isCreateInventoryLoading}
                  isLoadingText="Criando Inventário..."
                >
                  <WrenchAdjustableCircleFill />
                </CustomButton>
              </Center>
            </Col>
          </Row>
        </ComponentContent>
      </ComponentContainer>
    </>
  )
}
